<template>
  <div class="card-base reminder-card">
    <div class="reminder-title white-font">
      <span>Upcoming Trip Reminder</span>
      <img :src="icon" class="margin-left" alt />
    </div>
    <div class="text-center">
      <div class="reminder-left">
        <div class="calendar">
          <div class="calendar-title">{{firstJny.departureDate | toDateString("YYYY MMM")}}</div>
          <div class="calendar-content">
            {{firstJny.departureDate | toDateString("D")}}
            <span
              v-show="crossDay"
              class="cross-day"
            >+1</span>
          </div>
        </div>
      </div>
      <div class="reminder-right white-font">
        <div class="row">
          <div class="col-xs-4">
            <div class="station-info">
              <div>From</div>
              <div class="station">{{firstJny.origin}}</div>
              <div>
                <b>{{firstJny.departureDate | toDateString("HH:mm")}}</b>
              </div>
            </div>
          </div>
          <div class="col-xs-4">
            <img class="margin-top-x4" :src="arrow" alt />
          </div>
          <div class="col-xs-4">
            <div class="station-info">
              <div>To</div>
              <div class="station">{{firstJny.destination}}</div>
              <div>
                <b>{{firstJny.arrivalDate | toDateString("HH:mm")}}</b>
              </div>
            </div>
          </div>
        </div>
        <div class="row booking-pnr">
          <div class="col-xs-12">
            Booking Ref.
            <a :href="`#${booking.recordlocator}`" class="b">{{booking.recordlocator}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import images from "../../core/images";
import { stdFromJourneys } from "../../core/staff-helper";
export default {
  inheritAttrs: false,
  name: "reminder-card",
  props: {
    booking: {
      default: () => {}
    }
  },
  data() {
    let firstJny =
      this.booking.journeys.length > 0 ? this.booking.journeys[0] : {};
    return {
      firstJny: firstJny,
      std: stdFromJourneys(this.booking.journeys),
      crossDay:
        new Date(firstJny.departureDate).getDate() !==
        new Date(firstJny.arrivalDate).getDate()
    };
  },
  computed: {
    icon: () => images.reminderNotice,
    arrow: () => images.whiteArrow
  }
};
</script>
<style lang="scss" scoped>
.reminder-card {
  max-width: 360px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1rem;
  background-color: $orange;
  .reminder-title {
    line-height: 1.5;
    font-weight: bold;
    margin-bottom: 1rem;
    > * {
      vertical-align: middle;
    }
    img {
      width: 1.5rem;
    }
  }
  .reminder-left {
    width: 34%;
    vertical-align: top;
    display: inline-block;
    .calendar {
      font-weight: bold;
      background-color: #fff;
      border: solid 1px #000;
      .calendar-title {
        white-space: nowrap;
        padding: 0.5rem;
        font-size: 0.875rem;
        border-bottom: solid 1px #000;
        @media (max-width: 1200px) {
          padding: 0.25rem;
          font-size: 0.75rem;
        }
      }
      .calendar-content {
        font-size: 250%;
        .cross-day {
          font-size: 0.75rem;
        }
      }
    }
  }

  .reminder-right {
    width: 66%;
    padding-left: 0.5rem;
    vertical-align: top;
    display: inline-block;
    font-size: 0.8125rem;
    @media (max-width: 1200px) {
      font-size: 0.7rem;
    }
    .station {
      font-size: 200%;
    }
    .booking-pnr {
      margin-top: 0.375rem;
      a {
        color: white;
        text-decoration: none;
      }
    }
    img {
      width: 90%;
      margin-left: 5%;
    }
  }
  .row {
    margin-left: -0.25rem;
    margin-right: -0.25rem;
    .col-xs-4,
    .col-xs-5,
    .col-xs-7,
    .col-xs-12 {
      padding-left: 0.25rem;
      vertical-align: middle;
      padding-right: 0.25rem;
    }
  }
}
</style>
